import React from 'react';
import {Badge} from '../ui';

import './Label.css';

export interface IProps {
	value: string,
	onRemove?: {
		(label: string) : void
	}
}

function Label({value, onRemove} : IProps) {
	const handleClick = () => {
		if(!onRemove) return;
		onRemove(value);
	};

	return (
		<Badge pill bg="primary" className="label mr-1">
			<span role="label">{value}</span>
			{
				onRemove &&
				<button className="btn btn-ghost btn-xs p-0 min-h-0 h-auto" aria-label="Remove label" onClick={handleClick}>
					<i className="bi bi-x-circle-fill"></i>
				</button>
			}
		</Badge>
	);
}

export default Label;
